const initialState = {
    user: "all",
    status: "all",
    userStatus: "all",
    order: "newest",
    month: "",
};

const filtersReducer = (state = initialState, action) => {
    switch (action.type) {
        case "SET_FILTER":
            return {
                ...state,
                [action.payload.key]: action.payload.value,
            };
        default:
            return state;
    }
};

export default filtersReducer;
